/**
 * Rutas privadas permitidas sin registro en tabla `menus`.
 * Patrón cross-cutting (dashboard, wiki, unauthorized).
 */
export const ALLOWED_PERMIT_PATHS_ALL_USERS = [
  '/dashboard',
  '/home',
  '/unauthorized',
  '/documentation',
];

export const mergeMenuPathsWithPermitted = (menuPaths = []) => {
  const serverPaths = Array.isArray(menuPaths)
    ? menuPaths.filter((path) => typeof path === 'string' && path.length > 0)
    : [];

  return [...new Set([...serverPaths, ...ALLOWED_PERMIT_PATHS_ALL_USERS])];
};
